/* NEW PORT VELA V3: "La tripulación" page motion. Hero sea video (only while visible),
   manifesto that fills in word by word with scroll, a slow drift on the portrait,
   and pausing the wind streaks / photo strip while they are off screen. */
(function () {
  var root = document.querySelector('[data-crew]');
  if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var hasIO = 'IntersectionObserver' in window;

  /* hero video: load and play only when on screen */
  var video = root.querySelector('.crewp-hero__video');
  if (video && !reduce && !saveData && hasIO && !document.documentElement.classList.contains('no-inline-video')) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          if (!video.getAttribute('src')) video.src = video.getAttribute('data-src');
          var p = video.play(); if (p && p.catch) p.catch(function () {});
        } else { video.pause(); }
      });
    }, { threshold: 0.05 }).observe(video);
  }

  /* pause ambient loops off screen */
  if (hasIO) {
    var offIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    });
    root.querySelectorAll('.crewp-bf, .crewp-aboard').forEach(function (el) { el.classList.add('is-off'); offIO.observe(el); });
  }

  if (reduce) return;

  /* manifesto: split into words, fill with scroll */
  var fill = root.querySelector('[data-crew-fill]');
  var words = [];
  if (fill) {
    var parts = fill.textContent.trim().split(/\s+/);
    fill.textContent = '';
    parts.forEach(function (w, i) {
      var s = document.createElement('span'); s.className = 'w'; s.textContent = w;
      fill.appendChild(s); if (i < parts.length - 1) fill.appendChild(document.createTextNode(' '));
      words.push(s);
    });
  }
  var fig = root.querySelector('[data-crew-drift]');
  var img = fig && fig.querySelector('img');

  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight || 800;
    if (words.length) {
      var r = fill.getBoundingClientRect();
      var p = (vh * 0.9 - r.top) / (r.height + vh * 0.25);
      p = Math.max(0, Math.min(1, p));
      var n = words.length, k = p * (n + 3);
      for (var i = 0; i < n; i++) {
        var o = Math.max(0, Math.min(1, k - i));
        words[i].style.setProperty('--o', (0.16 + 0.84 * o).toFixed(3));
      }
    }
    if (img) {
      var fr = fig.getBoundingClientRect();
      if (fr.bottom > 0 && fr.top < vh) {
        var t = (fr.top + fr.height / 2 - vh / 2) / vh;
        img.style.setProperty('--drift', (Math.max(-0.5, Math.min(0.5, t)) * -60).toFixed(1) + 'px');
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  frame();
})();
